export const aciSchoolLocker = {
    iconName: 'school-locker',
    svgDef: {
        attr: { fill: 'none', viewBox: '0 0 25 24' },
        path: {
            attr: {
                d: 'M18.836 3H5.325a.844.844 0 00-.845.844v17.312c0 .466.379.844.845.844h13.511a.844.844 0 00.845-.844V3.844A.844.844 0 0018.835 3zM12.078 3v19M7.012 5.533h2.533M7.012 8.067h2.533M7.012 16.933h2.533M7.012 19.467h2.533M14.61 5.533h2.533M14.61 8.067h2.533M14.61 16.933h2.533M14.61 19.467h2.533M7.012 11.233V12.5M14.61 11.233V12.5',
                stroke: 'currentColor',
                'stroke-width': '1.2',
                'stroke-linecap': 'round',
                'stroke-linejoin': 'round',
            },
        },
    },
};
